<template>
  <Tag
    :value="isOrgReferenceActive(item) ? 'Active' : 'Inactive'"
    :severity="isOrgReferenceActive(item) ? 'success' : 'secondary'"
    class="text-xs"
  />
</template>

<script setup>
import Tag from 'primevue/tag';
import { isOrgReferenceActive } from '../utils/settingsOrgReferenceUtils';

defineOptions({ name: 'SettingsOrgReferenceStatusTag' });

defineProps({
  item: {
    type: Object,
    required: true,
  },
});
</script>
